module.exports = __webpack_public_path__ + "img/fast-messages.07e33265.svg";